import type { CampaignConfig } from "./types.js";
import {
  commonVisualAssetFiles,
  createCampaignVisualConfigFromManifest,
  withBase,
} from "./assets.js";
import { commonAuthoredFields } from "./common-fields.js";
import { engineSkills } from "./skills.js";
import { createSharedGridMap } from "./shared-grid.js";

const visualAssets = commonVisualAssetFiles;
const visual = createCampaignVisualConfigFromManifest({
  campaignId: "engine-v2",
  files: visualAssets,
  campaignLocalFiles: new Set<string>(),
});

export const engineV2Campaign: CampaignConfig = {
  id: "engine-v2",
  title: "TD Engine v2",
  storageKey: "td_engine_v2_save",
  tutorialStorageKey: "td_engine_v2_tutorial_done",
  map: createSharedGridMap(commonAuthoredFields),
  story: {
    initialBeatId: "intro",
    fieldWinBeats: {},
    beats: {
      intro: [
        { imageSrc: visualAssets.storyIntro, textKey: "story.intro.panel1" },
        { imageSrc: visualAssets.storyIntro, textKey: "story.intro.panel2" },
        { imageSrc: visualAssets.storyIntro, textKey: "story.intro.panel3" },
      ],
    },
  },
  visual,
  ui: {
    brandTitle: "TD Engine v2",
    brandIcon: "⚡",
    mageIcon: "P",
    mageLabelKey: "hud.priest",
    resourceLabelKey: "hud.grace",
    theme: "modern",
    waveTypeCodes: {
      Normal: "N",
      Swarm: "S",
      Armored: "A",
      Giant: "G",
      Runner: "R",
    },
  },
  audio: {
    tracks: {
      map: withBase("/assets/audio/maptheme.wav"),
      battle: withBase("/assets/audio/battletheme.wav"),
      win: withBase("/assets/audio/wintheme.wav"),
    },
  },
  skills: engineSkills,
};
